<div class="mila-ms" (keydown)="onKeydown($event)" (appClickOutside)="close()">

  <div class="field-input field-input--tag mila-ms__field" (mousedown)="open()">
    @for (opt of selected; track opt.id) {
      <span class="chip">
        {{ opt.label }}&nbsp;<span class="chip__remove" (mousedown)="remove(opt, $event)">×</span>
      </span>
    }
    <input
      #input
      type="text"
      class="filter-chip-input__field mila-ms__input"
      [value]="queryText"
      [placeholder]="selected.length ? '' : placeholder"
      (input)="onInput(input.value)"
      (focus)="open()"
    />
    @if (isLoading) {
      <!-- Was `isLoading && !options.length` that only ever matched the
           very first fetch. loadPage() doesn't clear `options` until the
           new response lands (see mila-multi-select.ts), so every fetch
           after the first runs with the *previous* query's results still
           sitting in `options`, making `!options.length` false and hiding
           the spinner even though a real request was in flight. -->
      <span class="mila-ms__spinner" aria-hidden="true"></span>
    }
  </div>

  <!-- Panel stays hidden not just empty while a fetch is in flight and
       there's nothing to show yet (first open, or a fresh query while the
       old results have already been filtered away): rendering it with
       nothing but 4px of container padding looked like a broken sliver.
       Once there's either something to show or the fetch has actually
       settled (so "No matches" is a real answer, not a placeholder), it
       renders normally. The spinner already on the input (above) is what
       signals "working on it" during that gap. -->
  @if (isOpen && (visibleOptions.length || !isLoading)) {
    <div class="mila-ms__list" (scroll)="onListScroll($event)">
      @for (opt of visibleOptions; track opt.id; let i = $index) {
        <div
          class="mila-ms__option"
          [class.mila-ms__option--hovered]="i === hoveredIndex"
          (mousedown)="select(opt); $event.preventDefault()"
          (mouseenter)="hoveredIndex = i"
        >{{ opt.label }}</div>
      }
      @if (!isLoading && !visibleOptions.length) {
        <div class="mila-ms__empty">No matches{{ queryText ? ' for "' + queryText + '"' : '' }}.</div>
      }
      @if (isLoading && visibleOptions.length) {
        <!-- Pagination only (loading more below options already on
             screen) the initial/empty case never reaches here now,
             since the panel above is hidden entirely for that one. -->
        <div class="mila-ms__loading-more">Loading…</div>
      }
    </div>
  }

  @if (limitMessage) {
    <p class="mila-ms__limit">{{ limitMessage }}</p>
  }

</div>
